import styled from 'styled-components';

export const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    align-items: start;
    justify-content: flex-end;
    padding: 4px;
`;

export const StyledLabel = styled.div.attrs(props => {
    const colors = ['#d90024', '#d3264b', '#88BDDA', '#6b9DBF', '#efefef', '#757575'];

    const setColor = () => {
        switch (props.type) {
            case 'task':
                return colors[3];

            case 'team-task':
                return colors[1];

            case 'tutoring':
                return colors[2];

            case 'exam':
                return colors[0];

            case 'live-class':
                return colors[4];

            case 'forum':
                return colors[5];

            default:
                return null;
        }
    };
    const textColor = () => {
        switch (props.type) {
            case 'live-class':
                return 'black';
            default:
                return 'white';
        }
    };
    return { backgroundColor: setColor(), color: textColor() };
})`
    /* traer type , de acuerdo a su string definir el color... */
    text-transform: uppercase;
    font-size: 10px;
    cursor: pointer;
    margin: 4px 0 2px;
    padding: 2px 10px 3px 9px;
    color: ${props => props.color};
    border-radius: 1rem;
    background: ${props => props.backgroundColor};
`;
